function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookmarkOutlined = function SvgBookmarkOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.2,
    d: "M5.6 21.375V4.5c0-.517.192-1.005.522-1.358A1.658 1.658 0 0 1 7.333 2.6h9.334c.445 0 .882.19 1.211.542.33.353.522.841.522 1.358v16.882l-6.097-3.564L12 17.64l-.303.177L5.6 21.382v-.007Z",
    style: {
      stroke: "currentColor"
    }
  }));
};
export default SvgBookmarkOutlined;